import React, { useEffect, useState } from 'react';
import './miPerfil.css';
import CustomInput from '../Common/textInput/CustomInput';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CustomButton from '../Common/wrappers/CustomButton';
import FormHelperText from '@material-ui/core/FormHelperText';
import * as Notification from '../Common/notification';
import { Grid, Box, Typography, Link } from '@mui/material';

const Misdatos = ({ usuario, sagaCambiarContrasenia }) => {
  const [cambiarContraseña, setCambiarContraseña] = useState(false);
  const [verContraseñaActual, setVerContraseñaActual] = useState(false);
  const [verNuevaContraseña, setVerNuevaContraseña] = useState(false);
  const [verRepetirContraseña, setVerRepetirContraseña] = useState(false);
  const [contraseñaActual, setContraseñaActual] = useState('');
  const [nuevaContraseña, setNuevaContraseña] = useState('');
  const [repetirContraseña, setRepetirContraseña] = useState('');
  const [coincidenContraseñaError, setCoincidenContraseñaError] = useState(false);
  const [ingresoContraseña, setIngresoContraseña] = useState(false);
  const [enviarFormulario, setEnviarFormulario] = useState(false);

  useEffect(() => {
    (contraseñaActual !== '' && nuevaContraseña !== '' && repetirContraseña !== '' && nuevaContraseña === repetirContraseña)
      ? setEnviarFormulario(true)
      : setEnviarFormulario(false);
  }, [contraseñaActual, nuevaContraseña, repetirContraseña]);

  const handleVerContraseñaActual = () => {
    setVerContraseñaActual(!verContraseñaActual);
  };

  const handleVerNuevaContraseña = () => {
    setVerNuevaContraseña(!verNuevaContraseña);
  };

  const handleVerRepetirContraseña = () => {
    setVerRepetirContraseña(!verRepetirContraseña);
  };

  const handleContraseñaActual = (e) => {
    setContraseñaActual(e.target.value);
  };

  const handleNuevaContraseña = (e) => {
    setNuevaContraseña(e.target.value);
  };

  const handleRepetirContraseña = (e) => {
    setRepetirContraseña(e.target.value);
  };

  const handleCerrar = () => {
    setCambiarContraseña(false);
    setContraseñaActual('');
    setNuevaContraseña('');
    setRepetirContraseña('');
    setCoincidenContraseñaError(false);
    setIngresoContraseña(false);
    setVerContraseñaActual(false);
    setVerNuevaContraseña(false);
    setVerRepetirContraseña(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    nuevaContraseña === repetirContraseña
      ? setCoincidenContraseñaError(false)
      : setCoincidenContraseñaError(true);
    nuevaContraseña === '' || repetirContraseña === '' || contraseñaActual === ''
      ? setIngresoContraseña(true)
      : setIngresoContraseña(false);

    if (enviarFormulario) {
      sagaCambiarContrasenia({
        idUsuario: usuario ? usuario.id : undefined,
        currentPassword: contraseñaActual,
        newPassword: nuevaContraseña,
        onContraseniaRestablecida: handleOnContraseniaUpdateada,
        onUpdateError: handleContraseniaUpdateadaError,
      });
    }
  };

  const handleOnContraseniaUpdateada = () => {
    Notification.showSuccess('La contraseña se actualizó correctamente');
    handleCerrar();
  };

  const handleContraseniaUpdateadaError = (error) => {
    Notification.showError(`Error al intentar cambiar la contraseña: ${error}`);
  };

  return (
    <Box className="misDatos-container">
      {usuario && (
        <form className="form-container">
          <Box className="form-item">
            <label>Nombre</label>
            <CustomInput type="text" value={usuario.nombre} readOnly />
          </Box>
          <Box className="form-item">
            <label>Apellido</label>
            <CustomInput type="text" value={usuario.apellido} readOnly />
          </Box>
          <Box className="form-item">
            <label>Email</label>
            <CustomInput type="text" value={usuario.nombreUsuario} readOnly />
          </Box>
          <Box className="form-item">
            <Link component="button" variant="body2" className='custom-link' onClick={() => setCambiarContraseña(true)}>
              Cambiar contraseña
            </Link>
          </Box>
        </form>
      )}

      {cambiarContraseña && (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} direction="column">
            <Grid item container justifyContent="space-between" alignItems="center">
              <Typography variant="h6">Cambiar contraseña</Typography>
            </Grid>
            <Grid item xs={12}>
              <CustomInput
                placeholder="Contraseña actual"
                value={contraseñaActual}
                type={verContraseñaActual ? 'text' : 'password'}
                name="contraseniaActual"
                onChange={handleContraseñaActual}
                error={false}
                icon={
                  verContraseñaActual ? (
                    <VisibilityIcon onClick={handleVerContraseñaActual} />
                  ) : (
                    <VisibilityOffIcon onClick={handleVerContraseñaActual} />
                  )
                }
              />
            </Grid>
            <Grid item container spacing={2}>
              <Grid item xs={12} sm={12} md={6}>
                <CustomInput
                  placeholder="Nueva contraseña"
                  value={nuevaContraseña}
                  type={verNuevaContraseña ? 'text' : 'password'}
                  name="nuevaContrasenia"
                  onChange={handleNuevaContraseña}
                  error={false}
                  icon={
                    verNuevaContraseña ? (
                      <VisibilityIcon onClick={handleVerNuevaContraseña} />
                    ) : (
                      <VisibilityOffIcon onClick={handleVerNuevaContraseña} />
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <CustomInput
                  placeholder="Repetir contraseña"
                  value={repetirContraseña}
                  type={verRepetirContraseña ? 'text' : 'password'}
                  name="repetirContrasenia"
                  onChange={handleRepetirContraseña}
                  error={false}
                  icon={
                    verRepetirContraseña ? (
                      <VisibilityIcon onClick={handleVerRepetirContraseña} />
                    ) : (
                      <VisibilityOffIcon onClick={handleVerRepetirContraseña} />
                    )
                  }
                />
                {coincidenContraseñaError && !ingresoContraseña && (
                  <FormHelperText error>
                    Las contraseñas no coinciden. Intente nuevamente.
                  </FormHelperText>
                )}
                {ingresoContraseña && (
                  <FormHelperText error>
                    Debe completar todos los campos para cambiar la contraseña.
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
            <Grid item container spacing={2}>
              <Grid item>
                <Box display="flex" gap={1}>
                  <CustomButton type="submit" color="primary" size="small" message="GUARDAR" />
                  <CustomButton color="primary" onClick={handleCerrar} size="small" message="CERRAR" />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}
    </Box>
  );
};

export default Misdatos;
